import { render, staticRenderFns } from "./PaymentResultTab.vue?vue&type=template&id=4f7503c2&scoped=true&"
import script from "./PaymentResultTab.vue?vue&type=script&lang=js&"
export * from "./PaymentResultTab.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResultTab.vue?vue&type=style&index=0&id=4f7503c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7503c2",
  null
  
)

export default component.exports